export default __webpack_public_path__ + "static/media/testAudio.56634dc4.mp3";